import { gql } from "@apollo/client";

export const clients = gql`
query Active_clients {
    aatmsv4_clients(order_by: {clientname: asc}, where: {active: {_eq: true}}) {
      clientname
      clientsid
      department
      headerrh1
      headerrh2
      headerrh3
      logo	  
    } } 

`
export const Fleets = gql `
query fleets_for_a_given_client(
    $Id: uuid
) {
    aatmsv4_fleets(order_by: {_aircraft: asc}, where: {clientsid: {_eq: $Id}}) {
      fleetsid
      aircraft
    } }
`
export const SubCatagory = gql`
query subcategories{
    aatmsv4_subcategory(order_by: {subcategoryid: asc}) {
        subcategoryid
      } }
`
export const phases = gql `
query da_aircraftform_tc(
    $clientId: uuid
    $fleetsid: uuid
    $phaseid: aatmsv4_phase_enum
) {
    aatmsv4_atclist(order_by: {atcname: asc}, where: {client: {clientsid: {_eq: $clientId}, _and: {fleets: {fleetsid: {_eq: $fleetsid}, _and: {_and: {active: {_eq: true}}}}}}, phase: {_eq: $phaseid}}) {
      atcid
      atcname
      ata
      phase
      atcshortname
    }
}
`
export const Phase = gql`
query MyQuery {
    aatmsv4_phase(order_by: {phaseid: asc}) {
      phaseid
    }
  }
`
export const addAircraftTemp = gql `
mutation da_aircraftform_tc_tempstore(
    $atcid: uuid
    $atcname: String
    $ata: Int
    $phase: aatmsv4_phase_enum
    $aircraftFormName: String
    $sequence: Int
    $shortName: String
) {
    insert_aatmsv4_atcmap(objects: {aircraftformname: $aircraftFormName,atcid: $atcid, ata: $ata, atcname: $atcname, atcshortname: $shortName, phase: $phase, sequence: $sequence, _crew: true, _ground: true, _simulator: true, _aircraft: true, _manager: true, _optimiser: true, active: false, published: false}) {
      returning {
        atcmapid
        atcshortname
        published
        active
      }
    }
  }
`
export const deleteAircrafts = gql`
mutation da_aircraftform_cancel {
  delete_aatmsv4_atcmap(where: {active: {_eq: false}, published: {_eq: false}}) {
    returning {
      atcmapid
    }
  }
}
`
export const  AircraftFormSubmit = gql`
mutation da_aircraftform_publish1(
  $clientsid: uuid
  $clientname: String
  $fleetsid: uuid
  $validit: Int
  $subcategory: aatmsv4_subcategory_enum
  $aircraftformname: String
  $ntc: Boolean
  $remarks: Boolean
  $result: Boolean
  $reginfo: String
) {
  insert_aatmsv4_aircraftforms(objects: {clientsid: $clientsid, clientname: $clientname, fleetsid: $fleetsid, validity: $validit, category: Aircraft, subcategory: $subcategory, aircraftformname: $aircraftformname, tc: true, ntc: $ntc, remarks: $remarks, result: $result, reginfo: $reginfo, blankform: "https://homepages.cae.wisc.edu/~ece533/images/fruits.png", active: true}) {
    returning {
      clientname
      clientsid
      fleetsid
      aircraftformid
      aircraftformname
      category
      subcategory
      validity
      ntc
      remarks
      tc
      result
      reginfo
      blankform
      active
    }   }
  insert_aatmsv4_uploads(objects: {clientsid: "cf12a191-f9ec-4307-b06b-c195c994f388", clientname: "Air One", uploader: "support@amiagi.com", url: "https://homepages.cae.wisc.edu/~ece533/images/fruits.png", _aircraft: true, _crew: true, _ground: false, _manager: true, _optimiser: true, _simulator: true, active: true}) {
    returning {
      url
      uploadid
    }     }    }
`
export const Update_Aircraft_Form = gql `
mutation da_aircraftform_publish2(
  $name: String
  $id: uuid
) {
  update_aatmsv4_atcmap(_set: {active: true, published: true, aircraftformid: $id}, where: {aircraftformname: {_eq: $name}}) {
    returning {
      sequence
      phase
      atcname
      published
      active
      atcmapid
      aircraftformid
    }
  }
}


`